import "./datatableSiteLocal.scss";
import {DataGrid, enUS, GridToolbar} from "@mui/x-data-grid";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";

const DataTableSiteLocal = ({columns}) => {
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    const [list, setList] = useState([]);
    const { data, loading, error } = useFetch(`/ticketsite`);


    useEffect(() => {
        setList(data);
    }, [data]);

    const handleDelete = async (id, token) => {
        try {
            console.log("Hapus data loading")
            await newRequest.delete(`/${path}/${id}` , {
                    headers: {
                        'Authorization': `$Bearer ${token}`
                    }
                }
            );
            setList(data.filter((item) => item.id !== id));

        } catch (err) {}
    };


    const actionColumn = [
        {
            field: "action_k",
            headerName: "Action",
            width: 600,
            renderCell: (params) => {
                return (
                    <div className="cellAction">
                        <Link to={`/ticketsite/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div className="viewButton">View</div>
                        </Link>
                        <Link to={`/ticketsite/update/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateButton"
                            >
                                Update Ticket Local Site
                            </div>
                        </Link>
                        <Link to={`/ticketsite/update/time/${params.row.id}`} style={{textDecoration: "none"}}>
                            <div
                                className="updateTimeButton"
                            >
                                Update Local Site Time
                            </div>
                        </Link>
                     {/*   <div
                            className="deleteButton"
                            onClick={() => handleDelete(params.row.id)}
                        >
                            Delete
                        </div>*/}

                    </div>
                );
            },
        },
    ];
    return (
        <div className="datatable">
            <div className="datatableTitle">
                {path.toUpperCase()} Local

            </div>
            <br/>

            <Link to={`/${path}/new`} className="link">
                Add New Ticket Local Site
            </Link>

            <br/>
            <br/>

            <DataGrid
                className="datagrid"
                rows={list}
                columns={columns.concat(actionColumn)}
                localeText={enUS.components.MuiDataGrid.defaultProps.localeText}
                components={{
                    Toolbar: GridToolbar
                }}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
                getRowId={(row) => row.id}

            />
        </div>
    );
};

export default DataTableSiteLocal;
